/**
 * Feature toggle which enables brands and retailers to paginate collections in the brand and retailer portal
 */
export const ENABLE_COLLECTIONS_PAGINATION_240711 = 'ENABLE_COLLECTIONS_PAGINATION_240711';
